import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2f33a48c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=2f33a48c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33a48c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f33a48c')) {
      api.createRecord('2f33a48c', component.options)
    } else {
      api.reload('2f33a48c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=2f33a48c&scoped=true", function () {
      api.rerender('2f33a48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableList/main.vue"
export default component.exports